import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './rootReducer';
import { DataChartEvents } from './types/astronautEventType';
import { formatAstronautEvents } from '../components/AstronautDataExplorer/util/AstronautDataExplorerConfigUtil';

export type DataChartEventsInitialState = {
  eventsDataDictionary: any;
  isDataEventsChartDataError: boolean;
  errorMessage: string;
};

export const dataChartEventsInitialState: DataChartEventsInitialState = {
  eventsDataDictionary: {},
  isDataEventsChartDataError: false,
  errorMessage: '',
};

export const dataChartEventsSlice = createSlice({
  name: 'dataChartEvents',
  initialState: dataChartEventsInitialState,
  reducers: {
    setDataChartEvents: (state, action: PayloadAction<DataChartEvents>) => {
      const { events } = action.payload;
      const eventsDataDictionary = formatAstronautEvents(events);

      state.eventsDataDictionary = eventsDataDictionary;
      state.isDataEventsChartDataError = false;
      state.errorMessage = '';
    },
    setDataChartEventsError: (state, action: PayloadAction<string>) => {
      state.eventsDataDictionary = {};
      state.isDataEventsChartDataError = true;
      state.errorMessage = action.payload;
    },
    resetDataChartEvents: (state) => {
      state.eventsDataDictionary = {};
      state.isDataEventsChartDataError = false;
      state.errorMessage = '';
    },
  },
});

export const {
  setDataChartEvents,
  setDataChartEventsError,
  resetDataChartEvents,
} = dataChartEventsSlice.actions;

export const eventsChartDataSelectors = {
  getEventsDataDictionary: (state: RootState) =>
    state.eventsChartData.eventsDataDictionary,
  getEventsDataErrorMessage: (state: RootState) =>
    state.eventsChartData.errorMessage,
};

export const getDataChartEvents = createAction<{
  entityId: string;
  startDate: string;
  endDate: string;
}>('GET_CHART_EVENTS_REQUEST');

export default dataChartEventsSlice.reducer;
